import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

export function EmptyState({
  Icon,
  title,
  description,
  action,
}: {
  Icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-st-lg border border-dashed border-st-line bg-st-surface px-6 py-12 text-center">
      {Icon && (
        <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-st-full bg-st-surface-2 text-st-primary">
          <Icon className="h-6 w-6" />
        </span>
      )}
      <h3 className="text-base font-semibold text-st-text">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-st-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
